import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { PuzzleHelpDialogInjectableInterface } from '../../shared-module/puzzle-help-dialog/puzzle-help-dialog-injectable.interface';
import { HelperFunctionsService } from '../../shared-module/helpers/helper-functions.service';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-word-search-help',
  templateUrl: './word-search-help.component.html',
  styleUrls: ['./word-search-help.component.scss'],
  standalone: true,
  imports: [CommonModule, IonText, TranslateModule],
})
export class WordSearchHelpComponent implements PuzzleHelpDialogInjectableInterface {
  data: { translationKey: 'string' };
  isMobile: boolean;
  hasSolutionWord: boolean;

  constructor(private helperFunctions: HelperFunctionsService, private framework: PuzzleFrameworkService) {
    this.isMobile = helperFunctions.isMobileDevice();
    this.hasSolutionWord = this.framework.puzzleHasSolutionWord();
  }

  setData(data: any): void {
    this.data = data;
  }
}
